export default "__VITE_ASSET__b388b73a__"